const parseDate = (dateString: string) => {
	if (!dateString) return null;
	return new Date(dateString);
};

const formatDate = (date?: Date) => {
	if (!date) return 'No Date';
	return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

const formatDateUTC = (date?: Date) => {
	if (!date) return 'No Date';
	return `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
};

const to24HourTime = (time12h?: string): string => {
	try {
		if (!time12h) return '';
		const { hour, minute } = parseHourMinutes(time12h);
		return formatTime24Hour(hour, minute);
	} catch {
		return time12h; // fallback to returning the original string if format is invalid
	}
};

const to12HourTime = (time24h?: string): string => {
	if (!time24h) return '';
	const match = time24h.trim().match(/^(\d{1,2}):(\d{2}):?(\d{2})?$/);
	if (!match) {
		return time24h; // fallback to returning the original string if format is invalid
	}
	const hour = parseInt(match[1], 10);
	const minute = parseInt(match[2], 10);
	return formatTime12Hour(hour, minute);
};

const parseHourMinutes = (time12h: string): { hour: number; minute: number } => {
	const match = time12h.trim().match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);

	if (!match) {
		throw new Error("Invalid time format. Expected 'h:mm AM/PM'");
	}

	let hour = parseInt(match[1], 10);
	const minute = parseInt(match[2], 10);
	const period = match[3].toUpperCase();

	if (period === 'PM' && hour !== 12) {
		hour += 12;
	} else if (period === 'AM' && hour === 12) {
		hour = 0;
	}

	return { hour, minute };
};

export const formatTime12Hour = (hour: number, minute: number): string => {
	const period = hour >= 12 ? 'PM' : 'AM';
	const hour12 = hour % 12 === 0 ? 12 : hour % 12;
	const minuteStr = minute.toString().padStart(2, '0');
	return `${hour12}:${minuteStr} ${period}`;
};

export const formatTime24Hour = (hour: number, minute: number): string => {
	const hourStr = hour.toString().padStart(2, '0');
	const minuteStr = minute.toString().padStart(2, '0');
	return `${hourStr}:${minuteStr}:00`;
};

export const dateUtil = {
	parseDate,
	formatDate,
	formatDateUTC,
	formatTime12Hour,
	formatTime24Hour,
	to24HourTime,
	to12HourTime,
	parseHourMinutes
};
